// src/generated/runtime.ts
var BASE_PATH = "http://localhost:8080".replace(/\/+$/, "");
var Configuration = class {
  constructor(configuration = {}) {
    this.configuration = configuration;
  }
  set config(configuration) {
    this.configuration = configuration;
  }
  get basePath() {
    return this.configuration.basePath != null ? this.configuration.basePath : BASE_PATH;
  }
  get fetchApi() {
    return this.configuration.fetchApi;
  }
  get middleware() {
    return this.configuration.middleware || [];
  }
  get queryParamsStringify() {
    return this.configuration.queryParamsStringify || querystring;
  }
  get username() {
    return this.configuration.username;
  }
  get password() {
    return this.configuration.password;
  }
  get apiKey() {
    const apiKey = this.configuration.apiKey;
    if (apiKey) {
      return typeof apiKey === "function" ? apiKey : () => apiKey;
    }
    return void 0;
  }
  get accessToken() {
    const accessToken = this.configuration.accessToken;
    if (accessToken) {
      return typeof accessToken === "function" ? accessToken : async () => accessToken;
    }
    return void 0;
  }
  get headers() {
    return this.configuration.headers;
  }
  get credentials() {
    return this.configuration.credentials;
  }
};
var DefaultConfig = new Configuration();
var BaseAPI = class _BaseAPI {
  constructor(configuration = DefaultConfig) {
    this.configuration = configuration;
    this.middleware = configuration.middleware;
  }
  static jsonRegex = new RegExp(
    "^(:?application/json|[^;/ 	]+/[^;/ 	]+[+]json)[ 	]*(:?;.*)?$",
    "i"
  );
  middleware;
  withMiddleware(...middlewares) {
    const next = this.clone();
    next.middleware = next.middleware.concat(...middlewares);
    return next;
  }
  withPreMiddleware(...preMiddlewares) {
    const middlewares = preMiddlewares.map((pre) => ({ pre }));
    return this.withMiddleware(...middlewares);
  }
  withPostMiddleware(...postMiddlewares) {
    const middlewares = postMiddlewares.map((post) => ({ post }));
    return this.withMiddleware(...middlewares);
  }
  /**
   * Check if the given MIME is a JSON MIME.
   * JSON MIME examples:
   *   application/json
   *   application/json; charset=UTF8
   *   APPLICATION/JSON
   *   application/vnd.company+json
   * @param mime - MIME (Multipurpose Internet Mail Extensions)
   * @return True if the given MIME is JSON, false otherwise.
   */
  isJsonMime(mime) {
    if (!mime) {
      return false;
    }
    return _BaseAPI.jsonRegex.test(mime);
  }
  async request(context, initOverrides) {
    const { url, init } = await this.createFetchParams(context, initOverrides);
    const response = await this.fetchApi(url, init);
    if (response && response.status >= 200 && response.status < 300) {
      return response;
    }
    throw new ResponseError(response, "Response returned an error code");
  }
  async createFetchParams(context, initOverrides) {
    let url = this.configuration.basePath + context.path;
    if (context.query !== void 0 && Object.keys(context.query).length !== 0) {
      url += "?" + this.configuration.queryParamsStringify(context.query);
    }
    const headers = Object.assign(
      {},
      this.configuration.headers,
      context.headers
    );
    Object.keys(headers).forEach(
      (key) => headers[key] === void 0 ? delete headers[key] : {}
    );
    const initOverrideFn = typeof initOverrides === "function" ? initOverrides : async () => initOverrides;
    const initParams = {
      method: context.method,
      headers,
      body: context.body,
      credentials: this.configuration.credentials
    };
    const overriddenInit = {
      ...initParams,
      ...await initOverrideFn({
        init: initParams,
        context
      })
    };
    let body;
    if (isFormData(overriddenInit.body) || overriddenInit.body instanceof URLSearchParams || isBlob(overriddenInit.body)) {
      body = overriddenInit.body;
    } else if (this.isJsonMime(headers["Content-Type"])) {
      body = JSON.stringify(overriddenInit.body);
    } else {
      body = overriddenInit.body;
    }
    const init = {
      ...overriddenInit,
      body
    };
    return { url, init };
  }
  fetchApi = async (url, init) => {
    let fetchParams = { url, init };
    for (const middleware of this.middleware) {
      if (middleware.pre) {
        fetchParams = await middleware.pre({
          fetch: this.fetchApi,
          ...fetchParams
        }) || fetchParams;
      }
    }
    let response = void 0;
    try {
      response = await (this.configuration.fetchApi || fetch)(
        fetchParams.url,
        fetchParams.init
      );
    } catch (e) {
      for (const middleware of this.middleware) {
        if (middleware.onError) {
          response = await middleware.onError({
            fetch: this.fetchApi,
            url: fetchParams.url,
            init: fetchParams.init,
            error: e,
            response: response ? response.clone() : void 0
          }) || response;
        }
      }
      if (response === void 0) {
        if (e instanceof Error) {
          throw new FetchError(
            e,
            "The request failed and the interceptors did not return an alternative response"
          );
        } else {
          throw e;
        }
      }
    }
    for (const middleware of this.middleware) {
      if (middleware.post) {
        response = await middleware.post({
          fetch: this.fetchApi,
          url: fetchParams.url,
          init: fetchParams.init,
          response: response.clone()
        }) || response;
      }
    }
    return response;
  };
  /**
   * Create a shallow clone of `this` by constructing a new instance
   * and then shallow cloning data members.
   */
  clone() {
    const constructor = this.constructor;
    const next = new constructor(this.configuration);
    next.middleware = this.middleware.slice();
    return next;
  }
};
function isBlob(value) {
  return typeof Blob !== "undefined" && value instanceof Blob;
}
function isFormData(value) {
  return typeof FormData !== "undefined" && value instanceof FormData;
}
var ResponseError = class extends Error {
  constructor(response, msg) {
    super(msg);
    this.response = response;
  }
  name = "ResponseError";
};
var FetchError = class extends Error {
  constructor(cause, msg) {
    super(msg);
    this.cause = cause;
  }
  name = "FetchError";
};
var RequiredError = class extends Error {
  constructor(field, msg) {
    super(msg);
    this.field = field;
  }
  name = "RequiredError";
};
var COLLECTION_FORMATS = {
  csv: ",",
  ssv: " ",
  tsv: "	",
  pipes: "|"
};
function exists(json, key) {
  const value = json[key];
  return value !== null && value !== void 0;
}
function querystring(params, prefix = "") {
  return Object.keys(params).map((key) => querystringSingleKey(key, params[key], prefix)).filter((part) => part.length > 0).join("&");
}
function querystringSingleKey(key, value, keyPrefix = "") {
  const fullKey = keyPrefix + (keyPrefix.length ? `[${key}]` : key);
  if (value instanceof Array) {
    const multiValue = value.map((singleValue) => encodeURIComponent(String(singleValue))).join(`&${encodeURIComponent(fullKey)}=`);
    return `${encodeURIComponent(fullKey)}=${multiValue}`;
  }
  if (value instanceof Set) {
    const valueAsArray = Array.from(value);
    return querystringSingleKey(key, valueAsArray, keyPrefix);
  }
  if (value instanceof Date) {
    return `${encodeURIComponent(fullKey)}=${encodeURIComponent(
      value.toISOString()
    )}`;
  }
  if (value instanceof Object) {
    return querystring(value, fullKey);
  }
  return `${encodeURIComponent(fullKey)}=${encodeURIComponent(String(value))}`;
}
function mapValues(data, fn) {
  return Object.keys(data).reduce(
    (acc, key) => ({ ...acc, [key]: fn(data[key]) }),
    {}
  );
}
function canConsumeForm(consumes) {
  for (const consume of consumes) {
    if ("multipart/form-data" === consume.contentType) {
      return true;
    }
  }
  return false;
}
var JSONApiResponse = class {
  constructor(raw, transformer = (jsonValue) => jsonValue) {
    this.raw = raw;
    this.transformer = transformer;
  }
  async value() {
    return this.transformer(await this.raw.json());
  }
};
var VoidApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return void 0;
  }
};
var BlobApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return await this.raw.blob();
  }
};
var TextApiResponse = class {
  constructor(raw) {
    this.raw = raw;
  }
  async value() {
    return await this.raw.text();
  }
};

// src/generated/models/Config.ts
function instanceOfConfig(value) {
  let isInstance = true;
  return isInstance;
}
function ConfigFromJSON(json) {
  return ConfigFromJSONTyped(json, false);
}
function ConfigFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    chainId: !exists(json, "chain_id") ? void 0 : json["chain_id"],
    auctionHouse: !exists(json, "auction_house") ? void 0 : json["auction_house"]
  };
}
function ConfigToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    chain_id: value.chainId,
    auction_house: value.auctionHouse
  };
}

// src/generated/models/EncryptLotIdPost200Response.ts
function instanceOfEncryptLotIdPost200Response(value) {
  let isInstance = true;
  return isInstance;
}
function EncryptLotIdPost200ResponseFromJSON(json) {
  return EncryptLotIdPost200ResponseFromJSONTyped(json, false);
}
function EncryptLotIdPost200ResponseFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    ciphertext: !exists(json, "ciphertext") ? void 0 : json["ciphertext"],
    x: !exists(json, "x") ? void 0 : json["x"],
    y: !exists(json, "y") ? void 0 : json["y"]
  };
}
function EncryptLotIdPost200ResponseToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    ciphertext: value.ciphertext,
    x: value.x,
    y: value.y
  };
}

// src/generated/models/EncryptRequest.ts
function instanceOfEncryptRequest(value) {
  let isInstance = true;
  return isInstance;
}
function EncryptRequestFromJSON(json) {
  return EncryptRequestFromJSONTyped(json, false);
}
function EncryptRequestFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    amount: !exists(json, "amount") ? void 0 : json["amount"],
    amountOut: !exists(json, "amount_out") ? void 0 : json["amount_out"],
    bidder: !exists(json, "bidder") ? void 0 : json["bidder"]
  };
}
function EncryptRequestToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    amount: value.amount,
    amount_out: value.amountOut,
    bidder: value.bidder
  };
}

// src/generated/models/PublicKey.ts
function instanceOfPublicKey(value) {
  let isInstance = true;
  return isInstance;
}
function PublicKeyFromJSON(json) {
  return PublicKeyFromJSONTyped(json, false);
}
function PublicKeyFromJSONTyped(json, ignoreDiscriminator) {
  if (json === void 0 || json === null) {
    return json;
  }
  return {
    x: !exists(json, "x") ? void 0 : json["x"],
    y: !exists(json, "y") ? void 0 : json["y"]
  };
}
function PublicKeyToJSON(value) {
  if (value === void 0) {
    return void 0;
  }
  if (value === null) {
    return null;
  }
  return {
    x: value.x,
    y: value.y
  };
}

// src/generated/apis/ConfigsApi.ts
var ConfigsApi = class extends BaseAPI {
  /**
   * Gets the supported auction modules for the provided configuration.
   */
  async configsAuctionModulesGetRaw(requestParameters, initOverrides) {
    if (requestParameters.xChainId === null || requestParameters.xChainId === void 0) {
      throw new RequiredError(
        "xChainId",
        "Required parameter requestParameters.xChainId was null or undefined when calling configsAuctionModulesGet."
      );
    }
    if (requestParameters.xAuctionHouse === null || requestParameters.xAuctionHouse === void 0) {
      throw new RequiredError(
        "xAuctionHouse",
        "Required parameter requestParameters.xAuctionHouse was null or undefined when calling configsAuctionModulesGet."
      );
    }
    const queryParameters = {};
    const headerParameters = {};
    if (requestParameters.xChainId !== void 0 && requestParameters.xChainId !== null) {
      headerParameters["x-chain-id"] = String(requestParameters.xChainId);
    }
    if (requestParameters.xAuctionHouse !== void 0 && requestParameters.xAuctionHouse !== null) {
      headerParameters["x-auction-house"] = String(
        requestParameters.xAuctionHouse
      );
    }
    const response = await this.request(
      {
        path: `/configs/auction_modules`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    return new JSONApiResponse(response);
  }
  /**
   * Gets the supported auction modules for the provided configuration.
   */
  async configsAuctionModulesGet(requestParameters, initOverrides) {
    const response = await this.configsAuctionModulesGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
  /**
   * Gets all supported configurations for the specified chain.
   */
  async configsChainChainIdGetRaw(requestParameters, initOverrides) {
    if (requestParameters.chainId === null || requestParameters.chainId === void 0) {
      throw new RequiredError(
        "chainId",
        "Required parameter requestParameters.chainId was null or undefined when calling configsChainChainIdGet."
      );
    }
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request(
      {
        path: `/configs/chain/{chain_id}`.replace(
          `{${"chain_id"}}`,
          encodeURIComponent(String(requestParameters.chainId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    return new JSONApiResponse(
      response,
      (jsonValue) => jsonValue.map(ConfigFromJSON)
    );
  }
  /**
   * Gets all supported configurations for the specified chain.
   */
  async configsChainChainIdGet(requestParameters, initOverrides) {
    const response = await this.configsChainChainIdGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
  /**
   * Gets all chain configurations supported by the API.
   */
  async configsGetRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request(
      {
        path: `/configs`,
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    return new JSONApiResponse(
      response,
      (jsonValue) => jsonValue.map(ConfigFromJSON)
    );
  }
  /**
   * Gets all chain configurations supported by the API.
   */
  async configsGet(initOverrides) {
    const response = await this.configsGetRaw(initOverrides);
    return await response.value();
  }
};

// src/generated/apis/KeysApi.ts
var KeysApi = class extends BaseAPI {
  /**
   * Encrypt a bid for a given lot ID. The bid will be encrypted using the public key for the lot and a randomized seed.
   */
  async encryptLotIdPostRaw(requestParameters, initOverrides) {
    if (requestParameters.xChainId === null || requestParameters.xChainId === void 0) {
      throw new RequiredError(
        "xChainId",
        "Required parameter requestParameters.xChainId was null or undefined when calling encryptLotIdPost."
      );
    }
    if (requestParameters.xAuctionHouse === null || requestParameters.xAuctionHouse === void 0) {
      throw new RequiredError(
        "xAuctionHouse",
        "Required parameter requestParameters.xAuctionHouse was null or undefined when calling encryptLotIdPost."
      );
    }
    if (requestParameters.lotId === null || requestParameters.lotId === void 0) {
      throw new RequiredError(
        "lotId",
        "Required parameter requestParameters.lotId was null or undefined when calling encryptLotIdPost."
      );
    }
    if (requestParameters.encryptRequest === null || requestParameters.encryptRequest === void 0) {
      throw new RequiredError(
        "encryptRequest",
        "Required parameter requestParameters.encryptRequest was null or undefined when calling encryptLotIdPost."
      );
    }
    const queryParameters = {};
    const headerParameters = {};
    headerParameters["Content-Type"] = "application/json";
    if (requestParameters.xChainId !== void 0 && requestParameters.xChainId !== null) {
      headerParameters["x-chain-id"] = String(requestParameters.xChainId);
    }
    if (requestParameters.xAuctionHouse !== void 0 && requestParameters.xAuctionHouse !== null) {
      headerParameters["x-auction-house"] = String(
        requestParameters.xAuctionHouse
      );
    }
    const response = await this.request(
      {
        path: `/encrypt/{lot_id}`.replace(
          `{${"lot_id"}}`,
          encodeURIComponent(String(requestParameters.lotId))
        ),
        method: "POST",
        headers: headerParameters,
        query: queryParameters,
        body: EncryptRequestToJSON(requestParameters.encryptRequest)
      },
      initOverrides
    );
    return new JSONApiResponse(
      response,
      (jsonValue) => EncryptLotIdPost200ResponseFromJSON(jsonValue)
    );
  }
  /**
   * Encrypt a bid for a given lot ID. The bid will be encrypted using the public key for the lot and a randomized seed.
   */
  async encryptLotIdPost(requestParameters, initOverrides) {
    const response = await this.encryptLotIdPostRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
  /**
   * Retrieve optimal decrypts for the next N bids to be decrypted on the a given lot ID. Works for any lot ID, assuming the private key for the auction has been submitted to the contract.
   */
  async hintsLotIdNumExternalGetRaw(requestParameters, initOverrides) {
    if (requestParameters.xChainId === null || requestParameters.xChainId === void 0) {
      throw new RequiredError(
        "xChainId",
        "Required parameter requestParameters.xChainId was null or undefined when calling hintsLotIdNumExternalGet."
      );
    }
    if (requestParameters.xAuctionHouse === null || requestParameters.xAuctionHouse === void 0) {
      throw new RequiredError(
        "xAuctionHouse",
        "Required parameter requestParameters.xAuctionHouse was null or undefined when calling hintsLotIdNumExternalGet."
      );
    }
    if (requestParameters.lotId === null || requestParameters.lotId === void 0) {
      throw new RequiredError(
        "lotId",
        "Required parameter requestParameters.lotId was null or undefined when calling hintsLotIdNumExternalGet."
      );
    }
    if (requestParameters.num === null || requestParameters.num === void 0) {
      throw new RequiredError(
        "num",
        "Required parameter requestParameters.num was null or undefined when calling hintsLotIdNumExternalGet."
      );
    }
    const queryParameters = {};
    const headerParameters = {};
    if (requestParameters.xChainId !== void 0 && requestParameters.xChainId !== null) {
      headerParameters["x-chain-id"] = String(requestParameters.xChainId);
    }
    if (requestParameters.xAuctionHouse !== void 0 && requestParameters.xAuctionHouse !== null) {
      headerParameters["x-auction-house"] = String(
        requestParameters.xAuctionHouse
      );
    }
    const response = await this.request(
      {
        path: `/hints/{lot_id}/{num}/external`.replace(
          `{${"lot_id"}}`,
          encodeURIComponent(String(requestParameters.lotId))
        ).replace(
          `{${"num"}}`,
          encodeURIComponent(String(requestParameters.num))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    return new JSONApiResponse(response);
  }
  /**
   * Retrieve optimal decrypts for the next N bids to be decrypted on the a given lot ID. Works for any lot ID, assuming the private key for the auction has been submitted to the contract.
   */
  async hintsLotIdNumExternalGet(requestParameters, initOverrides) {
    const response = await this.hintsLotIdNumExternalGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
  /**
   * Retrieve optimal decrypts for the next N bids to be decrypted on the a given lot ID. Assumes that the key information for the auction was created by the service.
   */
  async hintsLotIdNumGetRaw(requestParameters, initOverrides) {
    if (requestParameters.xChainId === null || requestParameters.xChainId === void 0) {
      throw new RequiredError(
        "xChainId",
        "Required parameter requestParameters.xChainId was null or undefined when calling hintsLotIdNumGet."
      );
    }
    if (requestParameters.xAuctionHouse === null || requestParameters.xAuctionHouse === void 0) {
      throw new RequiredError(
        "xAuctionHouse",
        "Required parameter requestParameters.xAuctionHouse was null or undefined when calling hintsLotIdNumGet."
      );
    }
    if (requestParameters.lotId === null || requestParameters.lotId === void 0) {
      throw new RequiredError(
        "lotId",
        "Required parameter requestParameters.lotId was null or undefined when calling hintsLotIdNumGet."
      );
    }
    if (requestParameters.num === null || requestParameters.num === void 0) {
      throw new RequiredError(
        "num",
        "Required parameter requestParameters.num was null or undefined when calling hintsLotIdNumGet."
      );
    }
    const queryParameters = {};
    const headerParameters = {};
    if (requestParameters.xChainId !== void 0 && requestParameters.xChainId !== null) {
      headerParameters["x-chain-id"] = String(requestParameters.xChainId);
    }
    if (requestParameters.xAuctionHouse !== void 0 && requestParameters.xAuctionHouse !== null) {
      headerParameters["x-auction-house"] = String(
        requestParameters.xAuctionHouse
      );
    }
    const response = await this.request(
      {
        path: `/hints/{lot_id}/{num}`.replace(
          `{${"lot_id"}}`,
          encodeURIComponent(String(requestParameters.lotId))
        ).replace(
          `{${"num"}}`,
          encodeURIComponent(String(requestParameters.num))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    return new JSONApiResponse(response);
  }
  /**
   * Retrieve optimal decrypts for the next N bids to be decrypted on the a given lot ID. Assumes that the key information for the auction was created by the service.
   */
  async hintsLotIdNumGet(requestParameters, initOverrides) {
    const response = await this.hintsLotIdNumGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
  /**
   * Create a new BN254 key pair. Returns the public key coordinates.
   */
  async newKeyPairPostRaw(initOverrides) {
    const queryParameters = {};
    const headerParameters = {};
    const response = await this.request(
      {
        path: `/new_key_pair`,
        method: "POST",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    return new JSONApiResponse(
      response,
      (jsonValue) => PublicKeyFromJSON(jsonValue)
    );
  }
  /**
   * Create a new BN254 key pair. Returns the public key coordinates.
   */
  async newKeyPairPost(initOverrides) {
    const response = await this.newKeyPairPostRaw(initOverrides);
    return await response.value();
  }
  /**
   * Retrieve the private key for a given lot ID. The private key will only be revealed after the auction for the lot has concluded. If an auction is cancelled, the private key will not be revealed.
   */
  async privateKeyLotIdGetRaw(requestParameters, initOverrides) {
    if (requestParameters.xChainId === null || requestParameters.xChainId === void 0) {
      throw new RequiredError(
        "xChainId",
        "Required parameter requestParameters.xChainId was null or undefined when calling privateKeyLotIdGet."
      );
    }
    if (requestParameters.xAuctionHouse === null || requestParameters.xAuctionHouse === void 0) {
      throw new RequiredError(
        "xAuctionHouse",
        "Required parameter requestParameters.xAuctionHouse was null or undefined when calling privateKeyLotIdGet."
      );
    }
    if (requestParameters.lotId === null || requestParameters.lotId === void 0) {
      throw new RequiredError(
        "lotId",
        "Required parameter requestParameters.lotId was null or undefined when calling privateKeyLotIdGet."
      );
    }
    const queryParameters = {};
    const headerParameters = {};
    if (requestParameters.xChainId !== void 0 && requestParameters.xChainId !== null) {
      headerParameters["x-chain-id"] = String(requestParameters.xChainId);
    }
    if (requestParameters.xAuctionHouse !== void 0 && requestParameters.xAuctionHouse !== null) {
      headerParameters["x-auction-house"] = String(
        requestParameters.xAuctionHouse
      );
    }
    const response = await this.request(
      {
        path: `/private_key/{lot_id}`.replace(
          `{${"lot_id"}}`,
          encodeURIComponent(String(requestParameters.lotId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    if (this.isJsonMime(response.headers.get("content-type"))) {
      return new JSONApiResponse(response);
    } else {
      return new TextApiResponse(response);
    }
  }
  /**
   * Retrieve the private key for a given lot ID. The private key will only be revealed after the auction for the lot has concluded. If an auction is cancelled, the private key will not be revealed.
   */
  async privateKeyLotIdGet(requestParameters, initOverrides) {
    const response = await this.privateKeyLotIdGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
  /**
   * Retrieve the public key for a given lot ID.
   */
  async publicKeyLotIdGetRaw(requestParameters, initOverrides) {
    if (requestParameters.xChainId === null || requestParameters.xChainId === void 0) {
      throw new RequiredError(
        "xChainId",
        "Required parameter requestParameters.xChainId was null or undefined when calling publicKeyLotIdGet."
      );
    }
    if (requestParameters.xAuctionHouse === null || requestParameters.xAuctionHouse === void 0) {
      throw new RequiredError(
        "xAuctionHouse",
        "Required parameter requestParameters.xAuctionHouse was null or undefined when calling publicKeyLotIdGet."
      );
    }
    if (requestParameters.lotId === null || requestParameters.lotId === void 0) {
      throw new RequiredError(
        "lotId",
        "Required parameter requestParameters.lotId was null or undefined when calling publicKeyLotIdGet."
      );
    }
    const queryParameters = {};
    const headerParameters = {};
    if (requestParameters.xChainId !== void 0 && requestParameters.xChainId !== null) {
      headerParameters["x-chain-id"] = String(requestParameters.xChainId);
    }
    if (requestParameters.xAuctionHouse !== void 0 && requestParameters.xAuctionHouse !== null) {
      headerParameters["x-auction-house"] = String(
        requestParameters.xAuctionHouse
      );
    }
    const response = await this.request(
      {
        path: `/public_key/{lot_id}`.replace(
          `{${"lot_id"}}`,
          encodeURIComponent(String(requestParameters.lotId))
        ),
        method: "GET",
        headers: headerParameters,
        query: queryParameters
      },
      initOverrides
    );
    return new JSONApiResponse(
      response,
      (jsonValue) => PublicKeyFromJSON(jsonValue)
    );
  }
  /**
   * Retrieve the public key for a given lot ID.
   */
  async publicKeyLotIdGet(requestParameters, initOverrides) {
    const response = await this.publicKeyLotIdGetRaw(
      requestParameters,
      initOverrides
    );
    return await response.value();
  }
};

// src/client.ts
import { cloakServers, Environment } from "@axis-finance/env";
var cloakApiUrl = cloakServers[Environment.PRODUCTION].url;
var defaultConfig = new Configuration({
  basePath: cloakApiUrl
});
var CloakClient = class {
  keysApi;
  configsApi;
  constructor(config = defaultConfig) {
    this.keysApi = new KeysApi(config);
    this.configsApi = new ConfigsApi(config);
  }
};
var createCloakClient = (config) => new CloakClient(config);
var cloakClient = new CloakClient();
export {
  BASE_PATH,
  BaseAPI,
  BlobApiResponse,
  COLLECTION_FORMATS,
  CloakClient,
  ConfigFromJSON,
  ConfigFromJSONTyped,
  ConfigToJSON,
  ConfigsApi,
  Configuration,
  DefaultConfig,
  EncryptLotIdPost200ResponseFromJSON,
  EncryptLotIdPost200ResponseFromJSONTyped,
  EncryptLotIdPost200ResponseToJSON,
  EncryptRequestFromJSON,
  EncryptRequestFromJSONTyped,
  EncryptRequestToJSON,
  FetchError,
  JSONApiResponse,
  KeysApi,
  PublicKeyFromJSON,
  PublicKeyFromJSONTyped,
  PublicKeyToJSON,
  RequiredError,
  ResponseError,
  TextApiResponse,
  VoidApiResponse,
  canConsumeForm,
  cloakClient,
  createCloakClient,
  exists,
  instanceOfConfig,
  instanceOfEncryptLotIdPost200Response,
  instanceOfEncryptRequest,
  instanceOfPublicKey,
  mapValues,
  querystring
};
//# sourceMappingURL=index.js.map